// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/addresses/AddressesEntry"),
  iconType: "environment",
  name: "addresses",
  subApps: [
    {
      name: "search",
      requirePermission: "address:areas"
    },
    {
      name: "batch-upload",
      requirePermission: "address:batch"
    },
    {
      name: "missing",
      requirePermission: "address:missing"
    },
    {
      name: "areas",
      requirePermission: "address:areas"
    }
  ]
}: AppType)
